import { map, some } from "lodash-es";

import { MDSIconKind } from "@/mds";
import type { AgentFilterSelectItem } from "@/pages/agent/components/agent-filter-select";
import { ALL_PROJECTS_FILTER } from "@/pages/agent/tasks/use-agent-tasks-search-params";

export type AgentTaskProjectFilterOption = {
  id: string;
  title: string;
};

export const buildTaskProjectFilterItems = ({
  projectFilter,
  projectOptions,
}: {
  projectFilter: string;
  projectOptions: AgentTaskProjectFilterOption[];
}): AgentFilterSelectItem[] => {
  const projectFilterItems: AgentFilterSelectItem[] = [
    {
      id: ALL_PROJECTS_FILTER,
      label: "All projects",
      iconKind: MDSIconKind.Folder,
    },
  ];
  const hasSelectedProject =
    projectFilter === ALL_PROJECTS_FILTER ||
    some(projectOptions, projectOption => projectOption.id === projectFilter);

  if (!hasSelectedProject) {
    projectFilterItems.push({
      id: projectFilter,
      label: "Selected project",
      iconKind: MDSIconKind.Folder,
    });
  }

  projectFilterItems.push(
    ...map(projectOptions, projectOption => ({
      id: projectOption.id,
      label: projectOption.title,
      iconKind: MDSIconKind.Folder,
    }))
  );

  return projectFilterItems;
};
